// import { useState } from "react";
// import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
// import Header from "../../component/Header";
// import "./style.css";
// import { Link } from "react-router-dom";
// import IconKey from "../../component/SvgIcons/IconKey";
// import { useAuth } from "../../context/AuthContext";
// import { AnimatePresence, motion } from "framer-motion";


// import { Card } from 'primereact/card';

// export default function UserDetails() {
//   const { authUser } = useAuth();
//   const [showPassword, setShowPassword] = useState(false);
//   const togglePassword = () => setShowPassword((prev) => !prev);
//   return (
//     <>
//       <Header title subtitle="View User Details" searchbar />
//       <div className="container profilePage">
//         <div className="card">
//           <Card title="Simple Card">
//             <p className="m-0">
//                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae
//               numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!
//             </p>
//           </Card>
//         </div>
//       </div>

// </>
// <div className="dashboard">
//   <div className="container">
//     <div className="card">
//       <Card title="Simple Card">
//         <p className="m-0">
//           Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae
//           numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!
//         </p>
//       </Card>
//     </div>
//     {/* <div className="center-content"> */}

//     {/* <AnimatePresence mode="wait">
//       <motion.form                
//         initial={{ opacity: 0, y: 10 }}
//         animate={{ opacity: 1, y: 0 }}
//         exit={{ opacity: 0, y: -10 }}
//         transition={{ duration: 0.3 }}
//       >  
//       <div className="pagegap d-flex flex-column">
//         <h2 className="create-titles mb-0 d-flex align-items-center">
//           <DiamondsFour /> User Details
//         </h2>

//         <div className="cardcontainer">
//           <div className="cardpicture">
//             <img
//               src="https://images.unsplash.com/photo-1610216705422-caa3fcb6d158?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDB8fGZhY2V8ZW58MHwyfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
//               alt="user card"
//             />
//           </div>
//           <div className="card">
//             <div className="infos">
//               <div className="name">
//                 <h2>{authUser?.Agent_Name}</h2>
//                 <h4><strong>Code :</strong> {authUser?.Code }</h4>
//               </div>
//               <ul className="stats">
//                 <li>
//                   <strong>Status</strong> {authUser?.Status}
//                 </li>
//                 <li>
//                   <strong>User Rights</strong> Customization, Download
//                   Manual, Support
//                 </li>
//                 <li>
//                   <strong>Mobile</strong> {authUser?.Phone_No}
//                 </li>
//                 <li>
//                   <strong>Email</strong> {authUser?.Email_Id}
//                 </li>
//                 <li>
//                   <strong>Address</strong> Ahmedabad, Gujarat 380015
//                 </li>
//                 <li>
//                   <strong>
//                     Password{" "}
//                     <Link
//                       onClick={togglePassword}
//                       className="tranparenteffect"
//                     >
//                       <IconKey />
//                     </Link>
//                   </strong>{" "}
//                   {showPassword ? "admin@123" : "*******"}
//                 </li>
//                 <li>
//                   <Link to="#">Forgot Password</Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </motion.form>
//     </AnimatePresence>           */}
//     {/* </div> */}
//   </div>
// </div>
//   );
// }


import { TabView, TabPanel } from 'primereact/tabview';
import Header from '../../component/Header';
import "./style.css";
import { useAuth } from '../../context/AuthContext';
import { useEffect } from 'react';

export default function UserDetails() {
  const { authUser } = useAuth();

  const getInitials = (name) => {
    if (!name) return '';
    const parts = name.trim().split(' ');
    const first = parts[0]?.[0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (first + last).toUpperCase();
  };

  useEffect(()=>{
    console.log(authUser)
  } , [])

  return (
    <>
      <Header title subtitle="User Details" searchbar />
      <div className='row center-content'>
        <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12 col-xs-12'>
          <div className="profileCard">
            <TabView>
              <TabPanel header="Profile">
                {/* <h6>Personal Information</h6> */}
                <div style={{ display: 'grid', justifyContent: 'center' }}>
                  <div className='profileImage'>
                    <div className='profile-avatar'>
                      {getInitials(authUser?.Agent_Name)}
                    </div>
                    {/* <img src="https://images.unsplash.com/photo-1610216705422-caa3fcb6d158?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDB8fGZhY2V8ZW58MHwyfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                      alt="user card"
                    /> */}
                  </div>
                  <div className='PersonalDetails'>
                    <h5> {authUser?.Agent_Name}</h5>
                    <p>{authUser?.Agents_Company}</p>
                  </div>
                </div>
                <div className='additionInfo'>
                  <div style={{ marginBottom: 10 }}>
                    <span style={{lineHeight : 1.5}}>Email </span><br></br>
                    <span style={{ color: '#000' }}>{authUser.Email_Id}</span><br></br>
                  </div>
                  <div>
                    <span style={{lineHeight : 1.5}}>Phone No </span><br></br>
                    <span style={{ color: '#000' }}>+91-{authUser.Phone_No}</span>
                  </div>
                       <div>
                    <span style={{lineHeight : 1.5}}>Extensions number : </span>
                    <span style={{ color: '#000' }}>{authUser.Extensions_Number}</span>
                  </div>
                </div>
              </TabPanel>
            </TabView>
          </div>
        </div>
      </div>
    </>
  )
}